"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listItem = exports.list = exports.linkReference = exports.link = exports.integerView = exports.inlineCode = exports.imageReferenceView = exports.imageReference = exports.image = exports.html = exports.heading = exports.groupView = exports.galleryView = exports.footnoteReference = exports.footnoteDefinition = exports.footnote = exports.fileView = exports.fileTableReferenceView = exports.fileReferenceView = exports.emphasis = exports.emailView = exports.del = exports.definition = exports.dateTimeView = exports.dateTimeRangeView = exports.dateRangeView = exports.dateView = exports.currencyRangeView = exports.currencyView = exports.collectionView = exports.codeView = exports.code = exports.checkboxSelectionView = exports.checkboxView = exports.calendarView = exports.br = exports.booleanView = exports.boardView = exports.blockquote = exports.createParentBuilder = exports.createRelativeTimeViewBuilder = exports.createNumberRangeViewBuilder = exports.createRangeViewBuilder = exports.createIntegerViewBuilder = exports.createCollectionViewBuilder = exports.createPickerViewBuilder = exports.createParentViewBuilder = exports.createViewBuilder = exports.createLiteralBuilder = exports.createNodeBuilder = void 0;
exports.yaml = exports.urlView = exports.toggleSwitchView = exports.timeView = exports.timeRangeView = exports.thematicBreak = exports.textView = exports.textAreaView = exports.text = exports.tableView = exports.tableRow = exports.tableCell = exports.table = exports.switchView = exports.strong = exports.stringView = exports.selectionView = exports.root = exports.richTextView = exports.relativeTimeView = exports.relativeDurationView = exports.relativeDelayView = exports.referenceView = exports.rangeView = exports.radioSelectionView = exports.percentRangeView = exports.percentView = exports.passwordView = exports.paragraph = exports.numberView = exports.numberRangeView = exports.multipleSelectionView = exports.listView = void 0;
const omit_1 = __importDefault(require("ramda/src/omit"));
const unist_builder_1 = __importDefault(require("unist-builder"));
const type_1 = require("./type");
function createNodeBuilder(nodeType) {
    const omitProps = omit_1.default(["type"]);
    return (props) => unist_builder_1.default(nodeType, omitProps(props));
}
exports.createNodeBuilder = createNodeBuilder;
function createLiteralBuilder(nodeType) {
    const omitProps = omit_1.default(["type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, omitProps(props), value);
}
exports.createLiteralBuilder = createLiteralBuilder;
function createViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, omitProps(Object.assign(Object.assign({}, defaults), props)), value);
}
exports.createViewBuilder = createViewBuilder;
function createParentViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["children", "type"]);
    return (props, children) => unist_builder_1.default(nodeType, omitProps(Object.assign(Object.assign({}, defaults), props)), children);
}
exports.createParentViewBuilder = createParentViewBuilder;
function createPickerViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["type", "value"]);
    return (props, value) => (Object.assign(Object.assign({}, unist_builder_1.default(nodeType, omitProps(Object.assign(Object.assign({}, defaults), props)))), (value !== undefined ? { value } : {})));
}
exports.createPickerViewBuilder = createPickerViewBuilder;
function createCollectionViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["type", "value"]);
    return (props, value) => (Object.assign(Object.assign({}, unist_builder_1.default(nodeType, omitProps(Object.assign(Object.assign({}, defaults), props)))), (value !== undefined ? { value } : {})));
}
exports.createCollectionViewBuilder = createCollectionViewBuilder;
function createIntegerViewBuilder(numberFormatStyle, nodeType, defaults) {
    const omitProps = omit_1.default(["style", "type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, Object.assign(Object.assign(Object.assign({}, omitProps(defaults)), omitProps(props)), { style: numberFormatStyle }), value);
}
exports.createIntegerViewBuilder = createIntegerViewBuilder;
function createRangeViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["style", "type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, Object.assign(Object.assign(Object.assign({}, omitProps(defaults)), omitProps(props)), { value }));
}
exports.createRangeViewBuilder = createRangeViewBuilder;
function createNumberRangeViewBuilder(numberFormatStyle, nodeType, defaults) {
    const omitProps = omit_1.default(["style", "type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, Object.assign(Object.assign(Object.assign({}, omitProps(defaults)), omitProps(props)), { style: numberFormatStyle, value }));
}
exports.createNumberRangeViewBuilder = createNumberRangeViewBuilder;
function createRelativeTimeViewBuilder(nodeType, defaults) {
    const omitProps = omit_1.default(["type", "value"]);
    return (props, value) => unist_builder_1.default(nodeType, Object.assign(Object.assign(Object.assign({}, omitProps(defaults)), omitProps(props)), { value }));
}
exports.createRelativeTimeViewBuilder = createRelativeTimeViewBuilder;
function createParentBuilder(nodeType) {
    const omitProps = omit_1.default(["children", "type"]);
    return (props, children) => unist_builder_1.default(nodeType, omitProps(props), children);
}
exports.createParentBuilder = createParentBuilder;
exports.blockquote = createParentBuilder(type_1.NodeType.BLOCKQUOTE);
exports.boardView = createCollectionViewBuilder(type_1.NodeType.BOARD_VIEW);
exports.booleanView = createViewBuilder(type_1.NodeType.BOOLEAN_VIEW);
exports.br = createNodeBuilder(type_1.NodeType.BREAK);
exports.calendarView = createCollectionViewBuilder(type_1.NodeType.CALENDAR_VIEW);
exports.checkboxView = createViewBuilder(type_1.NodeType.CHECKBOX_VIEW);
exports.checkboxSelectionView = createPickerViewBuilder(type_1.NodeType.CHECKBOX_SELECTION_VIEW);
exports.code = createLiteralBuilder(type_1.NodeType.CODE);
exports.codeView = createViewBuilder(type_1.NodeType.CODE_VIEW);
exports.collectionView = createCollectionViewBuilder(type_1.NodeType.COLLECTION_VIEW);
exports.currencyView = createIntegerViewBuilder(type_1.NumberFormatStyle.CURRENCY, type_1.NodeType.CURRENCY_VIEW, {
    currency: "USD",
    currencyDisplay: type_1.CurrencyDisplayType.SYMBOL,
});
exports.currencyRangeView = createNumberRangeViewBuilder(type_1.NumberFormatStyle.CURRENCY, type_1.NodeType.CURRENCY_RANGE_VIEW, {
    currency: "USD",
    currencyDisplay: type_1.CurrencyDisplayType.SYMBOL,
});
exports.dateView = createViewBuilder(type_1.NodeType.DATE_VIEW, {
    formatMatcher: "best fit",
    month: "numeric",
    day: "numeric",
    year: "2-digit",
});
exports.dateRangeView = createRangeViewBuilder(type_1.NodeType.DATE_RANGE_VIEW, {
    formatMatcher: "best fit",
    month: "numeric",
    day: "numeric",
    year: "2-digit",
});
exports.dateTimeRangeView = createRangeViewBuilder(type_1.NodeType.DATE_TIME_RANGE_VIEW, {
    formatMatcher: "best fit",
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour12: true,
    hour: "numeric",
    minute: "numeric",
});
exports.dateTimeView = createViewBuilder(type_1.NodeType.DATE_TIME_VIEW, {
    formatMatcher: "best fit",
    month: "numeric",
    day: "numeric",
    year: "2-digit",
    hour12: true,
    hour: "numeric",
    minute: "numeric",
});
exports.definition = createNodeBuilder(type_1.NodeType.DEFINITION);
exports.del = createParentBuilder(type_1.NodeType.DELETE);
exports.emailView = createViewBuilder(type_1.NodeType.EMAIL_VIEW);
exports.emphasis = createParentBuilder(type_1.NodeType.EMPHASIS);
exports.fileReferenceView = createViewBuilder(type_1.NodeType.FILE_REFERENCE_VIEW);
exports.fileTableReferenceView = createViewBuilder(type_1.NodeType.FILE_TABLE_REFERENCE_VIEW);
exports.fileView = createViewBuilder(type_1.NodeType.FILE_VIEW);
exports.footnote = createParentBuilder(type_1.NodeType.FOOTNOTE);
exports.footnoteDefinition = createParentBuilder(type_1.NodeType.FOOTNOTE_DEFINITION);
exports.footnoteReference = createNodeBuilder(type_1.NodeType.FOOTNOTE_REFERENCE);
exports.galleryView = createCollectionViewBuilder(type_1.NodeType.GALLERY_VIEW);
exports.groupView = createParentViewBuilder(type_1.NodeType.GROUP_VIEW);
exports.heading = createParentBuilder(type_1.NodeType.HEADING);
exports.html = createLiteralBuilder(type_1.NodeType.HTML);
exports.image = createNodeBuilder(type_1.NodeType.IMAGE);
exports.imageReference = createNodeBuilder(type_1.NodeType.IMAGE_REFERENCE);
exports.imageReferenceView = createViewBuilder(type_1.NodeType.IMAGE_REFERENCE_VIEW);
exports.inlineCode = createLiteralBuilder(type_1.NodeType.INLINE_CODE);
exports.integerView = createIntegerViewBuilder(type_1.NumberFormatStyle.DECIMAL, type_1.NodeType.INTEGER_VIEW);
exports.link = createParentBuilder(type_1.NodeType.LINK);
exports.linkReference = createParentBuilder(type_1.NodeType.LINK_REFERENCE);
exports.list = createParentBuilder(type_1.NodeType.LIST);
exports.listItem = createParentBuilder(type_1.NodeType.LIST_ITEM);
exports.listView = createCollectionViewBuilder(type_1.NodeType.LIST_VIEW);
exports.multipleSelectionView = createPickerViewBuilder(type_1.NodeType.MULTIPLE_SELECTION_VIEW);
exports.numberRangeView = createNumberRangeViewBuilder(type_1.NumberFormatStyle.DECIMAL, type_1.NodeType.NUMBER_RANGE_VIEW);
exports.numberView = createIntegerViewBuilder(type_1.NumberFormatStyle.DECIMAL, type_1.NodeType.NUMBER_VIEW);
exports.paragraph = createParentBuilder(type_1.NodeType.PARAGRAPH);
exports.passwordView = createViewBuilder(type_1.NodeType.PASSWORD_VIEW);
exports.percentView = createIntegerViewBuilder(type_1.NumberFormatStyle.PERCENT, type_1.NodeType.PERCENT_VIEW);
exports.percentRangeView = createNumberRangeViewBuilder(type_1.NumberFormatStyle.PERCENT, type_1.NodeType.PERCENT_RANGE_VIEW);
exports.radioSelectionView = createPickerViewBuilder(type_1.NodeType.RADIO_SELECTION_VIEW);
exports.rangeView = createRangeViewBuilder(type_1.NodeType.RANGE_VIEW);
exports.referenceView = createViewBuilder(type_1.NodeType.REFERENCE_VIEW);
exports.relativeDelayView = createRelativeTimeViewBuilder(type_1.NodeType.RELATIVE_DELAY_VIEW, {
    numeric: "auto",
    unit: "day",
});
exports.relativeDurationView = createRelativeTimeViewBuilder(type_1.NodeType.RELATIVE_DURATION_VIEW, {
    numeric: "auto",
    unit: "day",
});
exports.relativeTimeView = createRelativeTimeViewBuilder(type_1.NodeType.RELATIVE_TIME_VIEW, {
    numeric: "auto",
    unit: "day",
});
exports.richTextView = createViewBuilder(type_1.NodeType.RICH_TEXT_VIEW);
exports.root = createParentBuilder(type_1.NodeType.ROOT);
exports.selectionView = createPickerViewBuilder(type_1.NodeType.SELECTION_VIEW);
exports.stringView = createViewBuilder(type_1.NodeType.STRING_VIEW);
exports.strong = createParentBuilder(type_1.NodeType.STRONG);
exports.switchView = createViewBuilder(type_1.NodeType.SWITCH_VIEW);
exports.table = createParentBuilder(type_1.NodeType.TABLE);
exports.tableCell = createParentBuilder(type_1.NodeType.TABLE_CELL);
exports.tableRow = createParentBuilder(type_1.NodeType.TABLE_ROW);
exports.tableView = createCollectionViewBuilder(type_1.NodeType.TABLE_VIEW);
exports.text = createLiteralBuilder(type_1.NodeType.TEXT);
exports.textAreaView = createViewBuilder(type_1.NodeType.TEXT_AREA_VIEW);
exports.textView = createViewBuilder(type_1.NodeType.TEXT_VIEW);
exports.thematicBreak = createNodeBuilder(type_1.NodeType.THEMATIC_BREAK);
exports.timeRangeView = createRangeViewBuilder(type_1.NodeType.TIME_RANGE_VIEW, {
    formatMatcher: "best fit",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
});
exports.timeView = createViewBuilder(type_1.NodeType.TIME_VIEW, {
    formatMatcher: "best fit",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
});
exports.toggleSwitchView = createViewBuilder(type_1.NodeType.TOGGLE_SWITCH_VIEW);
exports.urlView = createViewBuilder(type_1.NodeType.URL_VIEW);
exports.yaml = createLiteralBuilder(type_1.NodeType.YAML);
//# sourceMappingURL=token.js.map